import React from 'react';

import Loading from 'components/cosmos/loading';
import { translate } from 'components/translate';
import flowRight from 'lodash/flowRight';
import { inject } from 'mobx-react';
import ClassListSearch from 'modules/classManager/classListView/ClassListSearch';
import ClassListSort from 'modules/classManager/classListView/ClassListSort';
import { ClassListViewCreateButton } from 'modules/classManager/classListView/classListViewCreateButton';
import { ClassListViewDescription } from 'modules/classManager/classListView/classListViewDescription';
import { ClassTable } from 'modules/classManager/classListView/classListViewDesktop/classTable';
import ClassListViewEmptyState from 'modules/classManager/classListView/ClassListViewEmptyState';
import ContentBasePage from 'modules/content/components/ContentBasePage';
import PropTypes from 'prop-types';

const ClassListViewDesktop = ({
  isLoading = true,
  hasClasses = false,
  hasSearch = false,
  t
}) => {
  const renderContent = () => {
    if (isLoading) {
      return <Loading center data-test="loader" />;
    }

    if (hasSearch && !hasClasses) {
      return <ClassListViewEmptyState />;
    }

    if (hasClasses) {
      return <ClassTable />;
    }

    return null;
  };

  return (
    <ContentBasePage className="content__grid" data-test="desktop-classs-view">
      <ContentBasePage.Header
        title={t('class_manager.class_list.title', { checkOnlineEvent: true })}
        isTitleLabel={false}
        className="_pb-2"
        hideBackHandler
      >
        <ClassListViewCreateButton />
      </ContentBasePage.Header>

      <ClassListViewDescription className="_mb-0" />

      <section className="_d-flex _align-items-center _justify-content-end _my-6">
        <ClassListSort className="_mr-4" />
        <ClassListSearch />
      </section>

      {renderContent()}
    </ContentBasePage>
  );
};

ClassListViewDesktop.propTypes = {
  isLoading: PropTypes.bool,
  hasClasses: PropTypes.bool,
  hasSearch: PropTypes.bool,
  t: PropTypes.func
};

export default flowRight(
  inject(({ ClassStore }) => ({
    isLoading: ClassStore.isFetchingFormattedClasses,
    hasClasses: ClassStore.classes.length > 0,
    hasSearch: ClassStore.search.length > 0
  })),
  translate()
)(ClassListViewDesktop);
